import { Route, Routes, Navigate } from "react-router-dom";
import App from "./App";
import CorkageApp from "./apps/CorkageApp";
import NewsApp from "./apps/NewsApp";
import TastingNotesApp from "./apps/TastingNotesApp";

function RoutesConfig() {
  return (
    <Routes>
      <Route path="/" element={<App />}>
        {/* Redirect from root to corkage */}
        <Route index element={<Navigate to="/corkage" replace />} />

        {/* Corkage app routes */}
        <Route path="corkage" element={<CorkageApp />} />
        <Route path="place/:placeId" element={<CorkageApp />} />

        {/* News app route */}
        <Route path="news" element={<NewsApp />} />

        {/* Tasting Notes app route */}
        <Route path="tasting-notes" element={<TastingNotesApp />} />

        {/* Catch-all redirect to corkage */}
        <Route path="*" element={<Navigate to="/corkage" replace />} />
      </Route>
    </Routes>
  );
}

export default RoutesConfig;
